import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import {
  ClearBulkHistoryOptions,
  ConfigurationNameChanged,
  GetStatusValues,
  ImportDateFromChanged,
  ImportDateFromCleared,
  ImportDateUntilChanged,
  ImportDateUntilCleared,
  PanelStatusChanged,
  StatusChanged,
} from '../actions/bulk-history.actions';
import { BulkHistoryState } from '../models/bulk.models';

const initialState: BulkHistoryState = {
  panelExpanded: true,
  configurationName: '',
  statusValues: [],
  status: '',
  importDateFrom: new Date(0),
  importDateFromFormat: '',
  importDateUntil: new Date(0),
  importDateUntilFormat: '',
};

export const BulkHistoryReducer = createReducer(
  initialState,
  on(PanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(GetStatusValues, (state, { statusValues }) => ({
    ...state,
    statusValues,
    status: statusValues[0],
  })),
  on(ConfigurationNameChanged, (state, { configurationName }) => ({
    ...state,
    configurationName,
  })),
  on(StatusChanged, (state, { status }) => ({
    ...state,
    status: status ?? '',
  })),
  on(ImportDateFromChanged, (state, { importDateFrom, importDateFromFormat }) => ({
    ...state,
    importDateFrom,
    importDateFromFormat,
  })),
  on(ImportDateFromCleared, (state) => ({
    ...state,
    importDateFrom: new Date(0),
    importDateFromFormat: '',
  })),
  on(ImportDateUntilChanged, (state, { importDateUntil, importDateUntilFormat }) => ({
    ...state,
    importDateUntil,
    importDateUntilFormat,
  })),
  on(ImportDateUntilCleared, (state) => ({
    ...state,
    importDateUntil: new Date(0),
    importDateUntilFormat: '',
  })),
  on(ClearBulkHistoryOptions, (state) => ({
    ...state,
    panelExpanded: true,
    configurationName: '',
    status: state.statusValues.length > 0 ? state.statusValues[0] : '',
    importDateFrom: new Date(0),
    importDateFromFormat: '',
    importDateUntil: new Date(0),
    importDateUntilFormat: '',
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    panelExpanded: true,
    configurationName: '',
    status: state.statusValues.length > 0 ? state.statusValues[0] : '',
    importDateFrom: new Date(0),
    importDateUntil: new Date(0),
  })),
);
